import React from "react";

import { Alert } from "@chakra-ui/react";
import InfoSvg from "./infoSvg";

const Info = ({ children }) => {
  return (
    <Alert status="info" colorScheme="#E5F2FD" padding="0">
      <div style={{ width: "100%" }}>
        <div
          style={{
            paddingTop: "10px",
            paddingBottom: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            {" "}
            <InfoSvg />
          </div>
          <div
            style={{
              paddingLeft: "8px",
            }}
          >
            {" "}
            {children}
          </div>
        </div>
      </div>
    </Alert>
  );
};

export default Info;
